import { Box, Heading, Text, VStack } from "@chakra-ui/react-v3";

export type SidePanelLayoutProps = {
  title: string;
  subtitle?: string;
  metadata?: string;
  children: React.ReactNode;
};

/**
 * Common layout structure for side panel content with header.
 * Provides consistent styling and spacing for all side panels.
 * The close button is handled generically by SidePanelDrawer.
 */
export function SidePanelLayout({ title, subtitle, metadata, children }: SidePanelLayoutProps) {
  return (
    <VStack align="stretch" gap={0} h="100%">
      {/* Header */}
      <Box p={6} borderBottom="1px solid" borderColor="border" bg="bg.panel">
        <VStack align="start" gap={1}>
          <Heading size="lg" color="fg">
            {title}
          </Heading>
          {subtitle && (
            <Text fontSize="sm" color="fg.muted">
              {subtitle}
            </Text>
          )}
          {metadata && (
            <Text fontSize="xs" color="fg.muted">
              {metadata}
            </Text>
          )}
        </VStack>
      </Box>

      {/* Content */}
      <Box flex={1} p={6}>
        <VStack align="stretch" gap={6}>
          {children}
        </VStack>
      </Box>
    </VStack>
  );
}
